import { create } from "zustand";
import produce from "immer";
import * as api from "../services/customer_properties";
import { arrayToByIdsAllIds, createLatestRequestTracker } from "./utils";

const trackListRequest = createLatestRequestTracker();

export const useCustomerPropertiesStore = create((set) => ({
  byIds: {},
  allIds: [],
  total: 0,
  fetchSome: async ({ q = "", filter = "", limit = 20, offset = 0 }) => {
    const isLatestRequest = trackListRequest();
    const some = await api.getSome({ q, filter, limit, offset });
    if (!isLatestRequest()) return;
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;

        // TODO make pagination work if we keep all data
        //[draft.byIds, draft.allIds] = arrayToByIdsAllIds([...Object.values(draft.byIds), ...some.data]);
        //draft.total = some.total;
      }),
    );
  },
  fetchSomeByAddress: async ({ q = "", limit = 20, offset = 0 }) => {
    const some = await api.getSomeByAddress({ q, limit, offset });
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;
      }),
    );
    return some;
  },
  getById: async ({ id }) => {
    const one = await api.getById({ id });
    set(
      produce((draft) => {
        draft.byIds[one.data.id] = one.data;
        if (!draft.allIds.includes(one.data.id)) {
          draft.allIds.push(one.data.id);
        }
      }),
    );
  },

  updateOne: async ({ id, number, name, address }) => {
    const one = await api.updateOne({
      id,
      number,
      name,
      address,
    });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },
}));
